
import React from 'react';
import { Flex } from '@fluentui/react-northstar';
import { observer } from "mobx-react-lite";
import RequestAssistanceButton from '../../atoms/RequestAssistanceButton';
import CancelAssistanceButton from '../../atoms/CancelAssistanceButton';
import callManagerHandler from '../../../services/api/callManagerHandler';
import agentHandler from "../../../../src/services/api/agentHandler";

const AssistanceButton = observer((props) => {
    const { agentId, alertDate, showAlert, dismissAlert } = props;

    const onClickRequestAssistance = () => {
        callManagerHandler.requestAssistance().catch((err) => {
            console.warn("Error requesting assistance...");
        });
        showAlert();
    };

    const onClickClearAssistance = () => {
        agentHandler.cancelRequestAssistance(agentId).catch((err) => {
            console.warn("Error clearing assistance...");
        });
        dismissAlert();
    };

    const requestButton = alertDate ?
        <CancelAssistanceButton onClick={onClickClearAssistance} /> : <RequestAssistanceButton onClick={onClickRequestAssistance} />;

    return (

        <Flex>
            {requestButton}
        </Flex>

    )
});

export default AssistanceButton;
